import React from "react";

/** Short, clean header labels matching Article List style. */
const LABEL_MAP = {
  "sl no": "#",
  "sl. no": "#",
  "s.no": "#",
  "s no": "#",
  "#": "#",
  image: "Thumb",
  logo: "Thumb",
  thumb: "Thumb",
  thumbnail: "Thumb",
  action: "Actions",
  actions: "Actions",
};

const TableHeader = ({ columns }) => {
  return (
    <thead className="manage-page-group-table-header xcruit-table">
      <tr>
        {columns.map((col, index) => {
          const raw = typeof col === "string" ? col.trim() : String(col);
          const mapped = LABEL_MAP[raw.toLowerCase()];
          return <th key={index}>{mapped || raw}</th>;
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
